import { every, isEmpty } from 'lodash';

export default function isObjectPresent(obj: object): boolean {
  return obj && Object.keys(obj).length !== 0 && !every(obj, isEmpty);
}
